import { VirtualTokenMap } from "./virtualTokenAction";

const initialState = {
  isLoading: false,
  tokenList: {},
  refreshTokenList: true,
  selectedVirtualToken: null,
  search: "",
  templates: [],
  searchText: "",
  skip: 0,
  limit: 10,
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case VirtualTokenMap.GET_ALL_VIRTUAL_TOKEN_START: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case VirtualTokenMap.GET_ALL_VIRTUAL_TOKEN_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        tokenList: action.payload,
        refreshTokenList: false,
      };
    }
    case VirtualTokenMap.GET_ALL_VIRTUAL_TOKEN_ERROR: {
      return {
        ...state,
        isLoading: false,
        refreshTokenList: false,
      };
    }
    case VirtualTokenMap.ADD_VIRTUAL_TOKEN_START: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case VirtualTokenMap.ADD_VIRTUAL_TOKEN_SUCCESS: {
      return {
        ...state,
        refreshTokenList: true,
      };
    }
    case VirtualTokenMap.ADD_VIRTUAL_TOKEN_ERROR: {
      return {
        ...state,
        isLoading: false,
        refreshTokenList: false,
      };
    }
    case VirtualTokenMap.UPDATE_VIRTUAL_TOKEN_START: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case VirtualTokenMap.UPDATE_VIRTUAL_TOKEN_SUCCESS: {
      return {
        ...state,
        refreshTokenList: true,
      };
    }
    case VirtualTokenMap.UPDATE_VIRTUAL_TOKEN_ERROR: {
      return {
        ...state,
        isLoading: false,
        refreshTokenList: false,
      };
    }
    case VirtualTokenMap.GET_ALL_TEMPLATES_START: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case VirtualTokenMap.GET_ALL_TEMPLATES_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        templates: action.payload,
        refreshTokenList: true,
      };
    }
    case VirtualTokenMap.GET_ALL_TEMPLATES_ERROR: {
      return {
        ...state,
        isLoading: false,
        templates: [],
        refreshTokenList: false,
      };
    }
    case VirtualTokenMap.SELECT_VIRTUAL_TOKEN_DETAILS: {
      return {
        ...state,
        isLoading: false,
        selectedVirtualToken: action.payload,
      };
    }
    case VirtualTokenMap.SEARCH_TEXT_CHANGE: {
      return {
        ...state,
        searchText: action.payload,
      };
    }
    case VirtualTokenMap.SET_VIRTUAL_TOKEN_BATCH_NUMBER: {
      return {
        ...state,
        skip: action.payload,
        refreshTokenList: true,
      };
    }
    case VirtualTokenMap.REFRESH_VIRTUAL_TOKEN_LIST: {
      return {
        ...state,
        skip: 0,
        refreshTokenList: true,
      };
    }
    case VirtualTokenMap.DELETE_VIRTUAL_TOKEN_START: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case VirtualTokenMap.DELETE_VIRTUAL_TOKEN_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        refreshTokenList: true,
      };
    }
    case VirtualTokenMap.DELETE_VIRTUAL_TOKEN_ERROR: {
      return {
        ...state,
        isLoading: false,
        refreshTokenList: false,
      };
    }
    default:
      return { ...state };
  }
};
